import { type LazyExoticComponent, Suspense, lazy, useEffect } from "react"

import LoadingScreen from "@sap/components/loading-screen"

import i18n from "@/locales/i18n"

function Loadable(
  Component: LazyExoticComponent<() => JSX.Element>,
  i18nNamespace: string = "common"
): React.FC {
  const ComponentWithSuspense: React.FC = (props) => {
    useEffect(() => {
      // Load translations
      i18n.loadNamespaces(i18nNamespace)
    }, [])

    return (
      <Suspense fallback={<LoadingScreen isDashboard />}>
        <Component {...props} />
      </Suspense>
    )
  }
  return ComponentWithSuspense
}

// auth
export const CallBack = Loadable(
  lazy(() => import("@/pages/login/CallBack")),
  "login"
)
export const Login = Loadable(
  lazy(() => import("@/pages/login")),
  "login"
)
export const Logout = Loadable(
  lazy(() => import("@/pages/login/logout")),
  "login"
)
export const Signup = Loadable(
  lazy(() => import("@/pages/login/signup")),
  "login"
)
export const Auth0Login = Loadable(
  lazy(() => import("@/pages/login/auth0login")),
  "login"
)

// main
export const NotFound = Loadable(lazy(() => import("@/pages/Page404")))
export const ServerError = Loadable(lazy(() => import("@/pages/Page500")))
export const Unauthorized = Loadable(lazy(() => import("@/pages/Page401")))
export const Root = Loadable(lazy(() => import("@/pages/root")))
export const Brands = Loadable(
  lazy(() => import("@/pages/information/brands")),
  "brands"
)
export const Item = Loadable(
  lazy(() => import("@/pages/item/component")),
  "item"
)
export const Fermob = Loadable(
  lazy(() => import("@/pages/colors/fermob")),
  "colors"
)

export const Coatings = Loadable(
  lazy(() => import("@/pages/colors/coatings")),
  "coatings"
)

export const Delivery = Loadable(
  lazy(() => import("@/pages/information/delivery")),
  "delivery"
)

export const FabricPrices = Loadable(
  lazy(() => import("@/pages/fabrics/prices")),
  "fabrics"
)

export const FabricInfo = Loadable(
  lazy(() => import("@/pages/fabrics/info")),
  "fabrics"
)

export const FabricOverview = Loadable(
  lazy(() => import("@/pages/fabrics/overview")),
  "fabrics"
)

export const Usps = Loadable(
  lazy(() => import("@/pages/information/usps")),
  "usps"
)

// admin
/* export const AdminDashboard = Loadable(lazy(() => import("@/pages/admin/view/Dashboard"))) */
export const AdminModelList = Loadable(lazy(() => import("@/pages/admin/model/list")))
export const AdminModelEdit = Loadable(lazy(() => import("@/pages/admin/model/edit")))
export const AdminModelTodos = Loadable(lazy(() => import("@/pages/admin/model/todos")))
export const AdminModelMissingProps = Loadable(
  lazy(() => import("@/pages/admin/model/missingProps"))
)
export const AdminPropertyList = Loadable(lazy(() => import("@/pages/admin/property/list")))
export const AdminPropertyCreate = Loadable(lazy(() => import("@/pages/admin/property/create")))

export const AdminAssociationList = Loadable(lazy(() => import("@/pages/admin/associations/list")))
